import { apiGet, apiPost, API_PATH } from "../api/client";

export interface JwtToken {
  accessToken: string;
  refreshToken: string;
  expiresAt: string;
  instanceId: number;
}

export interface QrScanResponse {
  qrToken: string;
  status: string;
}

export interface QrStatusResponse {
  qrToken?: string;
  deviceName?: string;
  os?: string;
  platform?: string;
  status: string;
  expiresAt?: string;
}

export interface QrConfirmResponse {
  status: string;
  message: string;
}

export const AuthService = {
  /**
   * Login with the raw initData string from Max Messenger.
   * The backend parses the URL-encoded query string, validates the hash,
   * extracts user data, and returns JWT tokens.
   */
  async login(initData: string): Promise<JwtToken> {
    return apiPost<JwtToken>(`${API_PATH}/minapp/login`, { initData });
  },

  /**
   * Rotates tokens using the refresh token issued at login.
   * Used to restore a session after the 15-minute access token expires,
   * without requiring a fresh initData from Max Messenger.
   */
  async refresh(refreshToken: string): Promise<JwtToken> {
    return apiPost<JwtToken>(`${API_PATH}/auth/refresh`, { refreshToken });
  },

  async qrScan(qrToken: string): Promise<QrScanResponse> {
    return apiPost<QrScanResponse>(
      `${API_PATH}/auth/qr/scan?qrToken=${encodeURIComponent(qrToken)}`,
    );
  },

  async qrStatus(qrToken: string): Promise<QrStatusResponse> {
    return apiGet<QrStatusResponse>(
      `${API_PATH}/auth/qr/status?qrToken=${encodeURIComponent(qrToken)}`,
    );
  },

  async qrConfirm(
    qrToken: string,
    approved: boolean,
  ): Promise<QrConfirmResponse> {
    return apiPost<QrConfirmResponse>(
      `${API_PATH}/auth/qr/confirm?qrToken=${encodeURIComponent(qrToken)}&approved=${approved}`,
    );
  },
};
